import ReferralsList from 'components/common/ReferralsList'

const Referrals = ({ visit }) => {
  const isSuccess = visit.isSuccess

  return (
    <div>
      <p className="typography-caption text-neutral-500">{!isSuccess ? 'PATIENT' : 'STUDENT'} REFERRALS</p>
      <ReferralsList visit={visit} />
    </div>
  )
}

export default Referrals
